import { getReviewStatus } from './review'

const getQuestEventLoggingData = quest => ({
  quest: {
    id: quest.id,
    name: quest.name
  },
  quest_status: getReviewStatus(quest),
  ...(Boolean(quest.type) && {
    quest_type: {
      id: quest.type.id,
      name: quest.type.name
    }
  }),
  ...(quest.managers.length > 0 && {
    manager: {
      id: quest.managers[0].id,
      name: quest.managers[0].name
    }
  })
})

export { getQuestEventLoggingData }



// WEBPACK FOOTER //
// ./src/utils/logging.js